const initGalleryLoadMore = () => {
  const sections = document.querySelectorAll('.gallery-section');
  if (!sections.length) return;

  sections.forEach((section) => {
    const grid = section.querySelector('[data-loadmore]');
    const btn = section.querySelector('.gallery-load-more');
    if (!grid || !btn) return;

    const items = Array.from(grid.querySelectorAll('.gallery-grid__item'));
    if (!items.length) {
      btn.classList.add('is-hidden');
      return;
    }

    const initial = parseInt(grid.dataset.initial || '6', 10);
    const step = parseInt(grid.dataset.step || '6', 10);

    let visibleCount = Math.min(initial, items.length);

    const applyVisibility = () => {
      items.forEach((item, idx) => {
        const hide = idx >= visibleCount;
        item.classList.toggle('is-hidden', hide);

        const desc = item.nextElementSibling;
        if (desc && desc.classList.contains('glightbox-desc')) {
          desc.classList.toggle('is-hidden', hide);
        }
      });

      if (visibleCount >= items.length) {
        btn.classList.add('is-hidden');
      } else {
        btn.classList.remove('is-hidden');
      }
    };

    // Init
    applyVisibility();

    btn.addEventListener('click', () => {
      visibleCount = Math.min(visibleCount + step, items.length);
      applyVisibility();
    });
  });
};

export { initGalleryLoadMore };
